"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getCurrentDomainID: ()=>external_domain_id_polyfill_js_namespaceObject.getCurrentDomainID,
    getI18nTTDomain: ()=>external_domain_id_util_js_namespaceObject.getI18nTTDomain,
    getDomainIDConfig: ()=>external_get_domain_id_config_js_namespaceObject.getDomainIDConfig,
    domainIDToRegionEnv: ()=>external_domain_id_polyfill_js_namespaceObject.domainIDToRegionEnv,
    getCurrentDomainIDOption: ()=>external_domain_id_util_js_namespaceObject.getCurrentDomainIDOption,
    currentDomainID: ()=>external_domain_id_polyfill_js_namespaceObject.currentDomainID,
    domainIDNameMap: ()=>external_domain_id_config_js_namespaceObject.domainIDNameMap,
    BaseBytecloudDomainIDService: ()=>external_base_domain_id_service_js_namespaceObject.BaseBytecloudDomainIDService,
    allDomainIDs: ()=>external_domain_id_config_js_namespaceObject.allDomainIDs,
    bytecloudDomainIDService: ()=>external_domain_id_service_js_namespaceObject.bytecloudDomainIDService,
    regionEnvToDomainID: ()=>external_domain_id_polyfill_js_namespaceObject.regionEnvToDomainID,
    domainIDHostnameMap: ()=>external_domain_id_config_js_namespaceObject.domainIDHostnameMap,
    domainIDUtil: ()=>external_domain_id_polyfill_js_namespaceObject.domainIDUtil
});
const external_domain_id_config_js_namespaceObject = require("./domain-id.config.js");
const external_domain_id_polyfill_js_namespaceObject = require("./domain-id.polyfill.js");
const external_domain_id_util_js_namespaceObject = require("./domain-id.util.js");
const external_domain_id_service_js_namespaceObject = require("./domain-id.service.js");
const external_base_domain_id_service_js_namespaceObject = require("./base-domain-id.service.js");
const external_get_domain_id_config_js_namespaceObject = require("./get-domain-id-config.js");
exports.BaseBytecloudDomainIDService = __webpack_exports__.BaseBytecloudDomainIDService;
exports.allDomainIDs = __webpack_exports__.allDomainIDs;
exports.bytecloudDomainIDService = __webpack_exports__.bytecloudDomainIDService;
exports.currentDomainID = __webpack_exports__.currentDomainID;
exports.domainIDHostnameMap = __webpack_exports__.domainIDHostnameMap;
exports.domainIDNameMap = __webpack_exports__.domainIDNameMap;
exports.domainIDToRegionEnv = __webpack_exports__.domainIDToRegionEnv;
exports.domainIDUtil = __webpack_exports__.domainIDUtil;
exports.getCurrentDomainID = __webpack_exports__.getCurrentDomainID;
exports.getCurrentDomainIDOption = __webpack_exports__.getCurrentDomainIDOption;
exports.getDomainIDConfig = __webpack_exports__.getDomainIDConfig;
exports.getI18nTTDomain = __webpack_exports__.getI18nTTDomain;
exports.regionEnvToDomainID = __webpack_exports__.regionEnvToDomainID;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BaseBytecloudDomainIDService",
    "allDomainIDs",
    "bytecloudDomainIDService",
    "currentDomainID",
    "domainIDHostnameMap",
    "domainIDNameMap",
    "domainIDToRegionEnv",
    "domainIDUtil",
    "getCurrentDomainID",
    "getCurrentDomainIDOption",
    "getDomainIDConfig",
    "getI18nTTDomain",
    "regionEnvToDomainID"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
